import { dcrScreenLabels, dcrScreenOriginalValue } from './data_change_request_question.utils';
import { getDcrTypeConfig } from '../constants';
import { EDcrType } from '../types';
const INACTIVE_STATUS_LABEL = 'Inactive';
/**
 * Fills in the read-only halves of a change: the current value a request is proposing to replace.
 * These are read back from the data the user selected rather than typed, so the review diff and
 * the stored payload agree on what the original value was at submission time.
 */
export const resolveDcrDerivedValues = ({ type, values, participantNumber, siteNumber, responses = [], scheduledVisits = [], screens = [], }) => {
    const config = getDcrTypeConfig(type);
    if (!config) {
        return {};
    }
    switch (config.type) {
        case EDcrType.UPDATE_PARTICIPANT_NUMBER:
            return { dcr_intake__original_value: participantNumber ?? '' };
        case EDcrType.MOVE_PARTICIPANT_TO_ANOTHER_SITE:
            return { dcr_intake__original_value: siteNumber ?? '' };
        case EDcrType.INACTIVATE_RESPONSE: {
            const response = responses.find((item) => String(item._id) === String(values.dcr_intake__task_response_id));
            return response
                ? {
                    dcr_intake__original_value: response.c_status ?? '',
                    dcr_intake__desired_value: INACTIVE_STATUS_LABEL,
                    dcr_intake__task_response_number: response.c_number ?? '',
                    dcr_intake__task_name: response.c_task?.c_name ?? '',
                }
                : {};
        }
        case EDcrType.UPDATE_SITE_RESPONSE:
        case EDcrType.UPDATE_PARTICIPANT_RESPONSE: {
            const screen = screens.find((item) => String(item.stepResponseId) === String(values.dcr_intake__step_response_id));
            const response = responses.find((item) => String(item._id) === String(values.dcr_intake__task_response_id));
            return {
                ...(screen && {
                    dcr_intake__original_value: dcrScreenOriginalValue(screen),
                    dcr_intake__step_id: screen.stepId,
                    dcr_intake__step_name: screen.name,
                    // Kept next to the code because the question is what the request is read back as
                    dcr_intake__step_question: dcrScreenLabels(screens)[String(screen.stepId)],
                }),
                ...(response && {
                    dcr_intake__task_response_number: response.c_number ?? '',
                    dcr_intake__task_name: response.c_task?.c_name ?? '',
                }),
            };
        }
        case EDcrType.UPDATE_VISIT_DATE: {
            const visit = scheduledVisits.find((item) => String(item.c_visit) === String(values.dcr_intake__visit_id));
            return {
                ...(visit && {
                    dcr_intake__original_value: visit.c_window_start_date ?? '',
                    dcr_intake__visit_name: visit.c_name ?? '',
                }),
            };
        }
        case EDcrType.MOVE_RESPONSES_TO_ANOTHER_VISIT: {
            const original = scheduledVisits.find((item) => String(item.c_visit) === String(values.dcr_intake__visit_id));
            const desired = scheduledVisits.find((item) => String(item.c_visit) === String(values.dcr_intake__desired_visit_id));
            return {
                ...(original && { dcr_intake__visit_name: original.c_name ?? '' }),
                ...(desired && { dcr_intake__desired_visit_name: desired.c_name ?? '' }),
            };
        }
        default:
            return {};
    }
};
